/**
 * @generated SignedSource<<d5d8e7a9064a1b6bea1ae7d03bcf2163>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ZohoDeleteAuthInput = {
  clientMutationId?: string | null | undefined;
  remove?: boolean | null | undefined;
};
export type Integration_ZohoDeleteAuth_Mutation$variables = {
  input: ZohoDeleteAuthInput;
};
export type Integration_ZohoDeleteAuth_Mutation$data = {
  readonly zohoDeleteAuth: {
    readonly success: boolean | null | undefined;
  } | null | undefined;
};
export type Integration_ZohoDeleteAuth_Mutation = {
  response: Integration_ZohoDeleteAuth_Mutation$data;
  variables: Integration_ZohoDeleteAuth_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ZohoDeleteAuthPayload",
    "kind": "LinkedField",
    "name": "zohoDeleteAuth",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Integration_ZohoDeleteAuth_Mutation",
    "selections": (v1/*: any*/),
    "type": "RootMutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Integration_ZohoDeleteAuth_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "fdd875446b2153ef8d0fec20eacafb28",
    "id": null,
    "metadata": {},
    "name": "Integration_ZohoDeleteAuth_Mutation",
    "operationKind": "mutation",
    "text": "mutation Integration_ZohoDeleteAuth_Mutation(\n  $input: ZohoDeleteAuthInput!\n) {\n  zohoDeleteAuth(input: $input) {\n    success\n  }\n}\n"
  }
};
})();

(node as any).hash = "58cb5fc156ba4d3e14d4624023af627b";

export default node;
